{
  "hero": {
    "title": "NAPAICP Trust Center",
    "description": "How the platform actually handles security, privacy, data, auditability, reliability, and accessibility, describing only what the system does today, not aspirational claims."
  },
  "quickNav": {
    "label": "On this page",
    "security": "Security",
    "privacy": "Privacy",
    "dataHandling": "Data handling",
    "auditability": "Auditability",
    "reliability": "Reliability",
    "accessibility": "Accessibility",
    "incident": "Incident contact"
  },
  "security": {
    "heading": "Security",
    "description": "Every measure below is live in production today, not a roadmap item.",
    "items": {
      "serverSideAuth": {
        "title": "Server-side authorization",
        "description": "Authentication and every authorization decision run on the server. Hiding a button in the UI is never the security boundary; direct API calls go through the same checks."
      },
      "privateStorage": {
        "title": "Private object storage",
        "description": "Submitted files live in private object storage with no public access."
      },
      "signedUrl": {
        "title": "Short-lived signed URLs",
        "description": "File upload and download use signed URLs valid for minutes, scoped to a specific operation and object, then expire."
      },
      "passwordHashing": {
        "title": "Password hashing",
        "description": "Passwords are stored using a versioned hashing scheme. The database never holds a plaintext password, and the system never logs what a user typed."
      },
      "competitionIsolation": {
        "title": "Competition isolation",
        "description": "Each competition's teams, submissions, and role permissions are isolated; participants in one competition cannot reach another competition's private data."
      },
      "auditTrail": {
        "title": "Append-only audit trail",
        "description": "Sensitive operations (permission changes, score locking, account governance) keep a record of who acted, when, and why. The audit trail is read-only; nothing can be deleted or edited out of it."
      },
      "eventServices": {
        "title": "Data protection for event services",
        "description": "A ride credential holds only a booking id and a signature, no personal data; rider mobile numbers and dietary notes are stored encrypted, the phone is viewable only by the event owner for urgent contact and each view is logged; email-only booking uses a single-use confirmation link valid for 30 minutes, stored hashed and protected by Turnstile and rate limiting; related data is deleted automatically after the event, with the retention period stated in the Data Policy."
      }
    }
  },
  "privacy": {
    "heading": "Privacy",
    "description": "What data we collect, why, who can access it, and how to request deletion: full detail on the Privacy page.",
    "cta": "Read the privacy notice"
  },
  "dataHandling": {
    "heading": "Data handling",
    "description": "Structured data (accounts, competitions, submissions, scores) and file storage are kept separate. Retention and deletion principles are on the Data Policy page.",
    "cta": "Read the data policy"
  },
  "auditability": {
    "heading": "Auditability",
    "description": "Result calculation, locking, and publishing, along with governance actions such as granting/revoking roles or suspending an account, all leave a record of who acted, when, why, and what changed. These records are not public; only authorized administrative roles can query them."
  },
  "reliability": {
    "heading": "Reliability",
    "description": "Production and Preview environments use isolated databases, file storage, and domains, so testing never touches production data. Bootstrap and first-administrator account recovery follow a documented runbook.",
    "deadlineOutage": "If a major platform outage happens before a submission deadline, an administrator can extend that competition's deadline; this action is itself recorded in the audit trail, including who made the change, when, and why."
  },
  "accessibility": {
    "heading": "Accessibility",
    "description": "Public pages follow WCAG 2.1 AA: keyboard operability, sufficient color contrast, identifiable form error messages, and responsive layout across desktop and mobile."
  },
  "incident": {
    "heading": "Incident contact",
    "description": "If you discover a security issue, have a privacy concern, or need help with a personal-data request, please reach us at the address below. For general questions about a specific competition (registration, judging, etc.), contact that competition's organizer first.",
    "contactLabel": "Security / privacy contact"
  }
}
